<template>

    <v-modal title="Save to Block Library?">
        <template #body>
            <transition name="fade">
                <v-alert class="mb-10" :message="error" />
            </transition>
            <p>You are about to save this block to your library so you can reuse it in emails and templates. Are you sure you want to add this block to your library?</p>
            <form @submit.prevent="submit">
                <v-select class="mb-10" :model="request" @input="request = $event">
                    <option value="create">Create New Block</option>
                    <option value="update">Update Existing Block</option>
                </v-select>
                <v-select v-if="request === 'update'" :model="params.id" @input="selectedBlock($event)">
                    <option value="">Select Block</option>
                    <option v-for="block in libraryCustom" :key="block.id" :value="block.id">{{ block.name }}</option>
                </v-select>
                <v-input v-else placeholder="Block Name" :model="params.name" @input="params.name = $event" />
            </form>
        </template>
        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="dismiss">Cancel</v-button>
            <v-button size="sm" :loading="loading" @click.native="submit">Save to Library</v-button>
        </template>
    </v-modal>

</template>

<script>

import BlockApi from '@api/BlockApi';
import BuilderUtil from '@builder/utils/BuilderUtil';
import Modal from './Modal';
import ProjectApi from '@api/ProjectApi';

export default {

    components: {
        'v-modal': Modal,
    },

    data() {
        return {
            loading: false,
            error: null,
            request: 'create',
            params: {},
        }
    },

    computed: {

        libraryCustom() {
            return this.$store.getters['builder/libraryCustom'];
        },

    },

    methods: {

        submit() {
            if (this.request === 'create') {
                this.createBlock();
            } else {
                this.updateBlock();
            }
        },

        createBlock() {
            this.loading = true;
            BuilderUtil.saveBlocks();
            let params = { block: this.$store.getters['builder/selectedBlock'] };
            params.name = this.params.name;
            ProjectApi.createBlock(this.project.id, params)
                .then((response) => {
                    this.loading = false;
                    // Set CSS.
                    this.setCss(response.data.data);
                    // Add to library.
                    let library = this.libraryCustom;
                    library.push(response.data.data);
                    library = library.sort((a, b) => a.name - b.name);
                    this.$store.commit('builder/setLibraryCustom', library);
                    // Success.
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                    this.dismiss();
                }, (error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        updateBlock() {
            this.loading = true;
            BuilderUtil.saveBlocks();
            let params = { block: this.$store.getters['builder/selectedBlock'] };
            params.name = this.params.name;
            BlockApi.updateBlock(this.params.id, params)
                .then((response) => {
                    this.loading = false;
                    // Set CSS.
                    this.setCss(response.data.data);
                    // Add to library.
                    let library = this.libraryCustom;
                    let index = library.findIndex(b => b.id === response.data.data.id);
                    library.splice(index, 1, response.data.data);
                    this.$store.commit('builder/setLibraryCustom', library);
                    // Success.
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                    this.dismiss();
                }, (error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        selectedBlock(id) {
            let block = this.libraryCustom.find(b => b.id === id);
            if (block) {
                this.params.id = block.id;
                this.params.name = block.name;
            } else {
                this.params = {};
            }
        },

        setCss(block) {
            let el = document.getElementById(`builder-styles-${block.id}`);
            if (el) {
                el.innerHTML = block.css;
            } else {
                let head = document.getElementsByTagName('head')[0];
                let style = document.createElement('style');
                style.id = `builder-styles-${block.id}`;
                style.innerHTML = block.css;
                head.appendChild(style);
            }
        },

        dismiss() {
            this.$store.commit('builder/setSelectedModal', null);
        },

    },

}

</script>